import { combineReducers } from "redux";
import createReducer from "utils/createReducer";

import * as list from "./list";
import * as details from "./details";
import * as create from "./create";
import * as nodes from "./nodes";
import * as workloads from "./workloads";
import * as scan from "./scan";
import * as updates from "./updates";

export default combineReducers({
  list: createReducer(list),
  details: createReducer(details),
  create: createReducer(create),
  nodes: createReducer(nodes),
  workloads: createReducer(workloads),
  scan: createReducer(scan),
  updates: createReducer(updates),
});
